<template>
  <div class="modal fade" id="modalCenter" data-bs-backdrop="static" tabindex="-1" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title mb-1" id="modalCenterTitle">{{ title }}</h5>
            <div v-if="modalSupplierName">
              Supplier: {{ modalSupplierName }}
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="table-responsive text-nowrap">
            <table class="table table-hover history-buy-price-table">
              <thead>
                <tr>
                  <th class="date-col">Date</th>
                  <th>Contract No</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th class="tax-col">Tax</th>
                  <th class="text-end history-action-col">Action</th>
                </tr>
              </thead>
              <tbody class="table-border-bottom-0">
                <tr v-if="!histories.length">
                  <td colspan="6" class="text-center text-muted py-3">No recent buy price data.</td>
                </tr>
                <tr
                  v-else
                  v-for="(history, historyIndex) in histories"
                  :key="history.contractId || history.contractNo || historyIndex"
                  :class="{ 'history-row-selected': selectedHistoryIndex === historyIndex }"
                  @mouseenter="$emit('hover-history', historyIndex)"
                  @mouseleave="$emit('clear-hover-history')"
                >
                  <td class="date-col">{{ formatHistoryDate(history.date) }}</td>
                  <td>{{ history.contractNo }}</td>
                  <td>{{ history.quantity }}</td>
                  <td><span>{{ formatHistoryPrice(getHistoryPriceInVnd(history)) }}</span></td>
                  <td class="tax-col">
                    <span class="tax-truncate" v-tooltip="formatBuyTaxes(history)">
                      {{ formatBuyTaxes(history) }}
                    </span>
                  </td>
                  <td class="text-end history-action-col">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary history-select-btn"
                      :class="{
                        'is-visible': hoveredHistoryIndex === historyIndex || selectedHistoryIndex === historyIndex,
                        'is-selected': selectedHistoryIndex === historyIndex
                      }"
                      @click="$emit('select-history', { history, historyIndex })"
                    >
                      <template v-if="selectedHistoryIndex === historyIndex">
                        <i class="bx bx-check"></i>
                      </template>
                      <template v-else>
                        Select
                      </template>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { utilities } from "../../services/utilities.js";

export default {
  name: "RecentBuyPriceModal",
  props: {
    title: {
      type: String,
      default: "Recent Buy Price"
    },
    histories: {
      type: Array,
      default: () => []
    },
    hoveredHistoryIndex: {
      type: Number,
      default: null
    },
    selectedHistoryIndex: {
      type: Number,
      default: null
    }
  },
  computed: {
    modalSupplierName() {
      const selectedHistory =
        Number.isInteger(this.selectedHistoryIndex) &&
        this.selectedHistoryIndex >= 0 &&
        this.selectedHistoryIndex < this.histories.length
          ? this.histories[this.selectedHistoryIndex]
          : null;

      if (selectedHistory && selectedHistory.supplier_name) {
        return selectedHistory.supplier_name;
      }

      const firstHistoryWithSupplier = this.histories.find(
        (item) => item && item.supplier_name
      );
      return firstHistoryWithSupplier ? firstHistoryWithSupplier.supplier_name : "";
    }
  },
  methods: {
    formatHistoryDate(dateValue) {
      if (!dateValue) return "";
      return utilities.changeFormatDate(dateValue);
    },
    formatBuyTaxes(history) {
      const taxPairs = [1, 2, 3]
        .map((index) => {
          const name = (history && history[`tax_buy_name_${index}`]) || "";
          const value = history && history[`tax_buy_value_${index}`];
          if (!name || value == null || value === "") return null;
          return `${name} ${Number(value).toLocaleString("en-US")}%`;
        })
        .filter(Boolean);

      return taxPairs.length ? taxPairs.join(" | ") : "-";
    },
    getHistoryPriceInVnd(history) {
      const price = Number((history && history.price) ?? 0);
      const rateEx = Number((history && history.rate_ex) ?? 1);
      return price * rateEx;
    },
    formatHistoryPrice(price) {
      if (price == null || price === "") return "VND 0";
      return `VND ${Number(price).toLocaleString("en-US")}`;
    }
  }
};
</script>

<style scoped>
  .history-buy-price-table {
    table-layout: fixed;
    width: 100%;
  }
  .history-buy-price-table .date-col {
    width: 140px;
  }
  .history-buy-price-table .tax-col {
    width: 170px;
    max-width: 170px;
  }
  .history-buy-price-table .history-action-col {
    width: 110px;
    min-width: 110px;
  }
  .history-select-btn {
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.12s ease;
  }
  .history-select-btn.is-visible {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  .history-buy-price-table tbody tr.history-row-selected td {
    background-color: var(--bs-primary, #696cff) !important;
    color: #fff;
  }
  .history-buy-price-table tbody tr.history-row-selected td span {
    color: #fff;
  }
  .history-select-btn.is-selected {
    min-width: 34px;
    padding-left: 0.45rem;
    padding-right: 0.45rem;
  }
  .tax-truncate {
    display: inline-block;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }
  @media (min-width: 992px) {
    .modal-lg, .modal-xl {
      --bs-modal-width: 60rem;
    }
  }
</style>
